/* eslint-disable @typescript-eslint/no-explicit-any */
'use client'
import { CartProvider as CartProv } from '@mercadoni/sinister/dist/cjs/cart/contexts'
import { monitor } from '@mercadoni/sinister/dist/cjs/monitors'
import { storage } from '@mercadoni/sinister/dist/cjs/shared/utils'

import defaultLocale from '@/stores/defaultLocale'
import getLocale from '@/stores/locales'
import { ProductCatalog } from '~types/index'
import { useReplacementsContext } from '../ReplacementsContext'
import MiddleWare from './MiddleWare'
import restoreCart from './useCase/restoreCart'

const db = storage('local')

const CartProvider = ({
  children,
  clientModel,
}: {
  children: React.ReactNode
  clientModel: any
}) => {
  const copies = getLocale() || defaultLocale
  const { clientId } = clientModel
  const { cart = {} } = copies
  const { onAddProduct } = useReplacementsContext()

  const onAddProductHandPicking = (product: ProductCatalog) => {
    onAddProduct({
      product,
    })
  }

  restoreCart()

  return (
    <CartProv
      site="web"
      db={db}
      monitor={monitor(true)}
      copy={cart}
      config={{
        clientId,
        enabledCoverageValidation: true,
      }}
    >
      <MiddleWare
        clientModel={clientModel}
        onAddProductHandPicking={onAddProductHandPicking}
      >
        {children}
      </MiddleWare>
    </CartProv>
  )
}

export default CartProvider
